export const datasecondchallenge = [
    {
      question: " ما هو السبب الرئيسي لتسوس الأسنان؟",
      option1: "قلة الكالسيوم",
      option2:"تراكم البكتيريا على الأسنان بسبب بقايا الطعام",
      option3: "شرب المياه الباردة",
      option4: "أكل الفواكه",
      ans: 2,
    },
    {
      question: "ما أهمية استخدام خيط الأسنان بجانب الفرشاة؟",
      option1: "يجعل الأسنان بيضاء",
      option2: "يزيل بقايا الطعام بين الأسنان ويقلل خطر التسوس",
      option3: "يقوي اللثة فقط",
      option4: " يعطي الفم رائحة جيدة ",
      ans: 2,
    },
    {
      question: "كم مرة يجب غسل الأسنان في اليوم على الأقل؟",
      option1: "مرة واحدة",
      option2: "مرتين",
      option3:"ثلاث مرات",
      option4: "كل ساعة",
      ans: 2,
    },
    {
      question: "إيه نوع الأطعمة اللي ممكن تضعف مينا الأسنان مع الوقت؟",
      option1: " الأطعمة الحارة",
      option2: "الأطعمة الحمضية مثل الليمون والمشروبات الغازية",
      option3: "الخبز",
      option4: "اللحوم",
      ans: 2,
    },
    {
      question: "أي من الآتي يساعد أكثر على حماية الأسنان من التسوس؟",
      option1: "شرب العصائر المحلاة",
      option2: "شرب مياه وفيرة وتنظيف الأسنان بانتظام",
      option3: " أكل الشوكولاتة الداكنة يوميًا",
      option4: "مضغ علكة محلاة بالسكر",
      ans: 2,
    },
    {
      question: "أي عادة صحية يجب الالتزام بها بعد زيارة طبيب الأسنان؟",
      option1: "تناول طعام لزج",
      option2: "ترك الأسنان بدون تنظيف لمدة يومين",
      option3: "اتباع تعليمات العناية مثل تنظيف الأسنان بخيط وفرشاة",
      option4: "شرب مشروبات باردة مباشرة",
      ans: 3,
    },
    {
      question: "إيه هي فائدة الفلوريد الموجود في معجون الأسنان؟",
      option1: "تلميع الأسنان بس",
      option2: "تقوية مينا الأسنان ومقاومة التسوس",
      option3: "تغيير لون الأسنان",
      option4:  "إعطاء نكهة منعشة فقط",
      ans: 2,
    },
  ];